export default __webpack_public_path__ + "static/24-a9a990986ce214b9020ca2239e72263b.jpg";